import React from "react";
import LoadSpinner from "../../common/spinner/loadSpinner";
import Menucustom from "../../common/menu/menucustom";
import { CDBCard, CDBContainer } from "cdbreact";
import { getFormatOraInput } from "../../common/utils";
import EsportaSpacchettatoService from "./EsportaSpacchettatoService";
import { toast } from "react-toastify";

export default class EsportaSpacchettatoSanzioni extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            filtro:{
                dataInizio:getFormatOraInput(new Date(new Date().getFullYear(),new Date().getMonth() - 1)),
                dataFine: getFormatOraInput(new Date(new Date().getFullYear(),new Date().getMonth() , 0)),
            }
        };

        this.esportaSpacchettatoService = new EsportaSpacchettatoService();
    }

    componentDidMount(){
        this.setState({loading:false})
    }

    onChangeDataInizio(event){
        this.setState((prevState)=>({filtro:{...prevState.filtro,dataInizio:event.target.value}}))
    }

    onChangeDataFine(event){
        this.setState((prevState)=>({filtro:{...prevState.filtro,dataFine:event.target.value}}))
    }

    downloadRicevuta(base64){
        const element = document.createElement('a')
        element.href = `data:application/csv;base64,${base64}`
        element.download = `sans_spachettato_${this.state.filtro.dataInizio}From_${this.state.filtro.dataFine}To.csv`
        document.body.appendChild(element)
        element.click()
    }

    esportaFile(){
        this.esportaSpacchettatoService.getSpacchettatoSanzioni(
            this.state.filtro.dataInizio,
            this.state.filtro.dataFine,
            (result)=>{
                this.downloadRicevuta(result)
            },
            (error)=>{
                toast.error("Errore. Riprova piu tardi", {
                    position: toast.POSITION.TOP_RIGHT,
                  });
            })
    }



    render(){
        return this.state.loading
        ? <LoadSpinner/>
        : (
            <div id="wrapper">
                <Menucustom/>
                <div className="container-fluid">
                    <br />
                    <br />
                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                        <h1 className="h1 mb-2 text-gray-800">
                        Gestione Sanzioni<br></br>
                        <small
                            style={{ fontSize: "14px" }}
                            className="mb-2 text-gray-800"
                        >Sanzioni&#8594;  Esporta Spacchettato
                        </small>
                        </h1>
                        </div>
                    <div>
                    <CDBContainer>
                        <CDBCard border>
                            <div className="container p-3">
                                <div className="row">
                                    <div className="col-5">
                                        <div className="col">Data Inizio: </div>
                                        <div className="col">
                                            <input
                                            value={this.state.filtro.dataInizio}
                                            type="date"
                                            className="form-control"
                                            onChange={this.onChangeDataInizio.bind(this)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-5">
                                        <div className="col">Data Fine: </div>
                                        <div className="col">
                                        <input
                                        value={this.state.filtro.dataFine}
                                        type="date"
                                        className="form-control"
                                        onChange={this.onChangeDataFine.bind(this)}
                                        />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <br/>
                                        <button className="btn btn-warning" onClick={()=>this.esportaFile()}>Esporta</button>

                                    </div>
                                </div>
                            </div>
                        </CDBCard>
                        </CDBContainer>
                    </div>
                </div>
            </div>
        )
    }
}